<template>
  <nav class="nav" :class="notPadded ? 'noPad' : ''">
    <div class="container">
      <div class="nav-left">
        <router-link :to="{ name: 'Home' }" class="nav-item">
          <logo></logo>
        </router-link>
      </div>

      <!-- This "nav-toggle" hamburger menu is only visible on mobile -->
      <!-- You need JavaScript to toggle the "is-active" class on "nav-menu" -->
      <button class="toggle" @click="toggleExpanded" :class="expanded ? 'toggled' : ''">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <!-- This "nav-first-of-typemenu" is hidden on mobile -->
      <!-- Add the modifier "is-active" to display it on mobile -->
      <div class="nav-right nav-menu" :class="expanded ? 'is-active' : ''">
        <div class="nav-item has-dropdown">
          <router-link :to="{ name: 'Episodes' }">
            <span>Stories</span>
          </router-link>
          <div class="dropdown">
            <router-link :to="{ name: 'Episodes' }">Episodes</router-link>
            <router-link :to="{ name: 'Books' }">Books</router-link>
            <router-link :to="{ name: 'Extras' }">Extras</router-link>
          </div>
        </div>
        <div class="nav-item has-dropdown">
          <router-link :to="{ name: 'About' }">
            <span>About</span>
          </router-link>
          <div class="dropdown">
            <router-link :to="{ name: 'About', hash: '#show' }">The Show</router-link>
            <router-link :to="{ name: 'About', hash: '#press' }">Press</router-link>
            <router-link :to="{ name: 'About', hash: '#contact' }">Contact</router-link>
            <router-link :to="{ name: 'About', hash: '#team' }">The Team</router-link>
            <router-link class="resources" :to="{ name: 'Resources' }">Resources</router-link>
          </div>
        </div>
        <div class="nav-item">
          <a href="https://longestshortesttime.supportingcast.fm/" target="_blank" rel="noopener noreferrer">
            <span>Join the Club</span>
          </a>
        </div>
        <div class="nav-item">
          <a href="https://the-longest-shortest-time.myshopify.com/" target="_blank" rel="noopener noreferrer">
            <span>Shop</span>
          </a>
        </div>
        <div class="nav-item mob" v-if="expanded">
          <search-module></search-module>
        </div>
        <div class="nav-item mob subscribe" v-if="expanded">
          <span>Subscribe</span>
          <subscribe-module></subscribe-module>
        </div>
      </div>
    </div>
    <div class="scrim" v-if="expanded" @click="unexpand"></div>
  </nav>
</template>

<script>
import Logo from './Logo'
import SearchModule from './SearchModule'
import SubscribeModule from './SubscribeModule'

export default {
  name: 'masthead',
  data() {
    return {
      expanded: false
    }
  },
  components: {
    Logo,
    SearchModule,
    SubscribeModule
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded
    },
    unexpand() {
      if (this.expanded) {
        this.expanded = false
      }
    }
  },
  computed: {
    notPadded() {
      return this.$route.name === 'Episodes' || this.$route.name === 'Extras' || this.$route.name === 'Category'
    }
  },
  watch: {
    '$route'(to, from) {
      this.unexpand()
    }
  }
}
</script>

<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  .scrim
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    z-index: 11

  .nav-item
    color: $textColor
    letter-spacing: 0.25px
    &:hover
      > a > span
        color: lighten($textColor, 25%)
    > a
      color: inherit

  .nav
    height: auto
    position: static
    +tablet
      position: relative
      padding-top: 36px
      padding-bottom: 60px
      background: transparent
    &.noPad
      padding-bottom: 0
    .container
      min-height: 0
      padding: 0 10px
      align-items: center
      +until($tablet)
        position: relative
        z-index: 20
      +tablet
        padding: 0 30px
        display: block
      +smDesktop
        display: flex
        justify-content: space-between
        align-items: flex-end
      +desktop
        padding: 0
      .toggle
        width: 36px
        height: 36px
        padding: 0
        background-color: $yellow
        border-radius: 50%
        +tablet
          display: none
        span
          margin-left: 0
          display: block
          width: 20px
          height: 2px
          background: $textColor
          margin-top: 0
          margin-left: auto
          margin-right: auto
          transition: opacity 100ms, transform 100ms, top 100ms linear 100ms
          position: relative
          top: 0
          &:nth-child(1)
            margin-bottom: 3px
          &:nth-child(3)
            margin-top: 3px
        &.toggled
          span
            transition: opacity 100ms, top 100ms, transform 100ms linear 100ms
            &:nth-child(1)
              top: 5px
              transform: rotate(45deg)
            &:nth-child(2)
              opacity: 0
            &:nth-child(3)
              top: -5px
              transform: rotate(-45deg)
      .nav-left
        overflow: visible
        +tablet
          flex: none
        .nav-item
          padding: 0
      .nav-right
        align-items: flex-end
        padding-bottom: 20px
        overflow: visible
        &.is-active
          +until($tablet)
            display: flex
            flex-direction: column
            > .nav-item
              width: 100%
              order: 1
              &.subscribe
                order: 0
                .social-nav
                  margin-right: 0
                  align-items: center
                  justify-content: space-between
        +tablet
          justify-content: space-between
          max-width: 420px
          .nav-item
            &:last-child
              padding-right: 0
        +smDesktop
          max-width: 520px
        +desktop
          max-width: 630px
        .nav-item
          text-transform: uppercase
          font-size: 20px
          font-weight: bold
          display: block
          text-align: left
          border-top: 0
          padding: 0 30px
          > a
            display: block
          span
            display: block
            border-top: 3px solid
          .dropdown
            +tablet
              top: 40px
            +desktop
              top: 68px
            +until($tablet)
              font-size: 15px
              margin-top: 2px
              margin-bottom: 18px
              a
                color: inherit
                text-transform: none
                &:hover
                  color: lighten($textColor, 25%)
                &:after
                  display: inline-block
                  content: '•'
                  margin: 0 10px
                &:last-child:after
                  content: ''
          &:nth-child(1)
            span, .dropdown
              border-color: $turquoise
          &:nth-child(2)
            span, .dropdown
              border-color: $yellow
          &:nth-child(3)
            span, .dropdown
              border-color: $green
          &:nth-child(4)
            span, .dropdown
              border-color: $orange
          +tablet
            padding: 0 1.5em 0 0
            font-size: 1.45em
            margin-top: 20px
            span
              border-top: none
              border-bottom: 8px solid
              display: block
              padding-bottom: 3px
              position: relative
              z-index: 1
              &:nth-child(1)
                padding-left: 0
            &.has-dropdown
              position: relative
              &:hover
                .dropdown
                  opacity: 1
                  pointer-events: auto
            .dropdown
              position: absolute
              background: #fff
              min-width: 100%
              text-align: left
              padding: 13px 33px 13px 18px
              line-height: 0
              border-bottom: 2px solid
              opacity: 0
              transition: opacity 350ms
              pointer-events: none
              left: 50%
              transform: translateX(-50%)
              a
                font-size: 15px
                font-weight: normal
                text-transform: none
                line-height: 1
                color: #000
                letter-spacing: 0.4px
                display: block
                padding: 7px
                white-space: nowrap
                &.resources
                  +tablet
                    display: none
                &:hover
                  text-decoration: underline
          +smDesktop
            padding: 0 0.75em
            margin-top: 0
            font-size: 1.5em
          +desktop
            padding: 0.75em
            font-size: 1.84em

  .sub
    order: 0
</style>



// WEBPACK FOOTER //
// Masthead.vue?299e5ae2